// @flow
import _ from 'lodash'
import isNil from 'lodash/isNil'
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import QuestionRow from 'utils/domain/FormBuilder/QuestionRow'

import BuilderQuestionSelectableItem from './BuilderQuestionSelectableItem'

type Props = {
  questionId: string,
  index: number,
  hasMakeBiggerOption: boolean,
  isDragDisabled: boolean,
}

function BuilderQuestion({
  questionId,
  index,
  hasMakeBiggerOption,
  isDragDisabled,
}: Props): React.Node {
  const {
    getQuestion,
    questionErrors,
    setQuestion,
    questionIdToScroll,
    setQuestionIdToScroll,
  } = React.useContext(FormBuilderContext)

  const questionRef = React.useRef()
  const question = getQuestion(questionId)

  const errors = _.get(questionErrors, questionId, [])

  React.useEffect(() => {
    // eslint-disable-next-line
    if (questionId === questionIdToScroll) {
      window.scrollTo({
        left: 0,
        top: _.max([(questionRef?.current?.offsetTop || 0) - 32, 0]),
        behavior: 'smooth',
      })
      setQuestionIdToScroll(null)
    }
  }, [questionId, questionIdToScroll, setQuestionIdToScroll])

  function addRowToTableInBuilder() {
    const questionRow = new QuestionRow({
      order: question.question_rows.length + 1,
      question: question.id,
      text: `Row ${question.question_rows.length}${1}`,
    })
    question.question_rows.push(questionRow)
    setQuestion(question.id, question)
  }

  if (isNil(question)) return null

  if (isDragDisabled) {
    return (
      <BuilderQuestionSelectableItem
        addRowToTableInBuilder={addRowToTableInBuilder}
        errors={errors}
        hasMakeBiggerOption={hasMakeBiggerOption}
        isDragDisabled={isDragDisabled}
        question={question}
        questionRef={questionRef}
      />
    )
  }

  return (
    <Draggable draggableId={questionId} index={index} key={questionId}>
      {(provided) => (
        <BuilderQuestionSelectableItem
          addRowToTableInBuilder={addRowToTableInBuilder}
          errors={errors}
          hasMakeBiggerOption={hasMakeBiggerOption}
          isDragDisabled={isDragDisabled}
          provided={provided}
          question={question}
          questionRef={questionRef}
        />
      )}
    </Draggable>
  )
}

export default BuilderQuestion
